export default "__VITE_ASSET__YFYJlhjj__"